<div class="bg-modal-cotizador py-2 overflow-y-auto">
  <div class="container">
    <div class="flex flex-wrap">
      <div class="w-full block md:hidden mx-auto">
        <div (click)="onNoClick()" class="hide-rectangle"></div>
      </div>
    </div>
    <div class="flex flex-wrap mx-[0.5rem] mb-[1.5rem] mt-[1rem] mx-auto">
      <div class="w-11/12">
        <h4 class="text-[24px] font-extrabold mb-0">
          <ng-container *ngIf="showPromoSplitWarning; else stepTitle">
            {{ 'MODAL.PROMO_SPLIT.TITLE' | translate }}
          </ng-container>
          <ng-template #stepTitle>
            <ng-container [ngSwitch]="reservationStep">
              <ng-container *ngSwitchCase="3">{{
                'MODAL.TITLE_CONFIRM' | translate
              }}</ng-container>
              <ng-container *ngSwitchCase="2">{{
                'MODAL.TITLE_PICKUP' | translate
              }}</ng-container>
              <ng-container *ngSwitchDefault>{{
                (data.promotion ? 'MODAL.TITLE_QUOTE_PROMOTION' : 'MODAL.TITLE_QUOTE') | translate
              }}</ng-container>
            </ng-container>
          </ng-template>
        </h4>
      </div>
      <div class="w-1/12 hidden lg:block">
        <button
          class="-mt-2.5"
          (click)="onNoClick()"
          mat-icon-button
          color="accent"
          [attr.aria-label]="'MODAL.CLOSE_ARIA_LABEL' | translate"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
    </div>
    <div class="reservation-step-container">
      <div
        class="promo-split-warning mx-auto px-[0.5rem] my-[1rem]"
        *ngIf="showPromoSplitWarning && promoSplitPreview"
      >
        <p class="promo-split-warning__description">
          {{ 'MODAL.PROMO_SPLIT.DESCRIPTION' | translate }}
        </p>

        <div class="promo-split-table" role="table">
          <div class="promo-split-table__header" role="row">
            <span role="columnheader">{{
              'MODAL.PROMO_SPLIT.COL_CONCEPT' | translate
            }}</span>
            <span role="columnheader">{{
              'MODAL.PROMO_SPLIT.COL_AMOUNT' | translate
            }}</span>
            <span role="columnheader">{{
              'MODAL.PROMO_SPLIT.COL_RATE' | translate
            }}</span>
          </div>

          <div class="promo-split-table__row" role="row">
            <span role="cell">{{
              'MODAL.PROMO_SPLIT.ROW_PROMOTION' | translate
            }}</span>
            <span role="cell">
              ${{ promoSplitPreview.promoAmount | number : '1.0-2' }}
              {{ promoSplitPreview.currencyCode }}
            </span>
            <span role="cell">
              ${{ promoSplitPreview.promoRate | number : '1.2-2' }} MXN
            </span>
          </div>

          <div class="promo-split-table__row" role="row">
            <span role="cell">{{
              'MODAL.PROMO_SPLIT.ROW_EXCESS' | translate
            }}</span>
            <span role="cell">
              ${{ promoSplitPreview.normalAmount | number : '1.0-2' }}
              {{ promoSplitPreview.currencyCode }}
            </span>
            <span role="cell">
              ${{ promoSplitPreview.regularRate | number : '1.2-2' }} MXN
            </span>
          </div>

          <div class="promo-split-table__row promo-split-table__row--total" role="row">
            <span role="cell">{{
              'MODAL.PROMO_SPLIT.ROW_TOTAL' | translate
            }}</span>
            <span role="cell">
              ${{ promoSplitPreview.totalAmount | number : '1.0-2' }}
              {{ promoSplitPreview.currencyCode }}
            </span>
            <span class="promo-split-table__average" role="cell">
              <span class="promo-split-table__average-label">{{
                'MODAL.PROMO_SPLIT.AVERAGE_LABEL' | translate
              }}</span>
              ${{ promoSplitPreview.averageRate | number : '1.2-2' }} MXN
            </span>
          </div>
        </div>

        <p class="promo-split-warning__note">
          <span class="promo-split-warning__note-label">{{
            'MODAL.PROMO_SPLIT.NOTE_LABEL' | translate
          }}</span>
          {{ 'MODAL.PROMO_SPLIT.NOTE_TEXT' | translate }}
        </p>
      </div>

      <div
        class="flex flex-wrap justify-center mx-auto px-[0.5rem] my-[1rem]"
        *ngIf="reservationStep === 1 && !showPromoSplitWarning"
      >
        <p
          class="w-full text-center mt-[1rem] text-[14px] quote-validation-error"
          *ngIf="marketInactive"
          role="alert"
        >
          {{ 'INVENTORY.MARKET_INACTIVE_TEXT' | translate }}
        </p>
        <app-quoter
          (amountChange)="recibirCotizacion($event)"
          [queDivisaTienes]="queDivisaTienes"
          [queDivisaQuieres]="queDivisaQuieres"
          [divisas]="divisas"
          [sucursal]="sucursal"
          [quotes]="cotizacion"
          [promoLocked]="isPromoLocked"
          [disabled]="marketInactive"
        >
        </app-quoter>

        <div
          class="w-full text-center mt-[1rem] text-[14px] quote-validation-error"
          *ngIf="reservationStep === 1 && quoteValidationErrorKey"
          role="alert"
        >
          {{ quoteValidationErrorKey | translate }}
        </div>

        <ng-container *ngIf="data.promotion && promoAvailability; else standardExchangeRate">
          <div class="promo-info-row w-full mt-[1rem]">
            <mat-icon class="promo-info-row__icon" svgIcon="payments"></mat-icon>
            <span class="promo-info-row__text">
              {{
                'MODAL.EXCHANGE_RATE_REGULAR_LABEL'
                  | translate
                    : {
                        toCurrency: promoForeignCurrencyCode
                      }
              }}
              <span class="promo-info-row__rate-strikethrough">
                ${{ promoAvailability.regularRate | number : '1.2-2' }} MXN
              </span>
            </span>
          </div>
          <div class="promo-info-row w-full mt-[1rem]">
            <mat-icon class="promo-info-row__icon" svgIcon="payments"></mat-icon>
            <span class="promo-info-row__text">
              {{ 'MODAL.EXCHANGE_RATE_PROMOTIONAL_LABEL' | translate }}
              <span class="promo-info-row__rate-promotional">
                ${{ promoAvailability.effectivePromotionRate | number : '1.2-2' }} MXN
              </span>
            </span>
          </div>
        </ng-container>
        <ng-template #standardExchangeRate>
          <div class="w-full text-center mt-[1rem] text-[14px]">
            {{
              'MODAL.EXCHANGE_RATE'
                | translate
                  : {
                      toCurrency: (queDivisaQuieres.currency.code | currencyName : queDivisaQuieres.currency.name),
                      rate: (displayExchangeRate | number : '1.2-2'),
                      fromCurrency: (queDivisaTienes.currency.code | currencyName : queDivisaTienes.currency.name)
                    }
            }}
          </div>
        </ng-template>

        <div
          class="promo-info-row w-full mt-[1rem]"
          *ngIf="promoAvailability && data.promotion"
        >
          <mat-icon class="promo-info-row__icon" svgIcon="schedule"></mat-icon>
          <span class="promo-info-row__text">
            {{
              'LANDING.PROMOTIONS.CARD_AVAILABILITY'
                | translate
                  : {
                      amount: (promoAvailability.availableAmount | number : '1.0-2'),
                      currency: promoAvailability.currencyCode
                    }
            }}
          </span>
        </div>

        <p
          class="promo-disclaimer w-full mt-[1rem]"
          *ngIf="data.promotion"
        >
          {{ 'MODAL.PROMOTIONAL_RATE_DISCLAIMER' | translate }}
        </p>

        <div
          class="overnight-notice w-full mt-[1rem]"
          [class.overnight-notice--promo]="data.promotion"
          *ngIf="showOvernightNotice"
        >
          <div class="overnight-notice__headline">
            <mat-icon
              *ngIf="data.promotion"
              class="overnight-notice__icon"
              svgIcon="help_outline"
            ></mat-icon>
            <svg
              *ngIf="!data.promotion"
              class="overnight-notice__icon"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fill="#FF4D50"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
              />
            </svg>
            <p class="overnight-notice__title">
              {{
                'MODAL.OUT_OF_HOURS_HEADLINE'
                  | translate : { date: overnightQuotationTimestamp }
              }}
            </p>
          </div>
          <p class="overnight-notice__detail">
            {{ 'MODAL.OUT_OF_HOURS_DETAIL_PREFIX' | translate }}
            <span class="overnight-notice__emphasis">{{
              'MODAL.OUT_OF_HOURS_OVERNIGHT_LABEL' | translate
            }}</span
            >{{ 'MODAL.OUT_OF_HOURS_DETAIL_MIDDLE' | translate }}
            <span class="overnight-notice__emphasis">{{
              overnightPickupTimeRange
            }}</span
            >{{ 'MODAL.OUT_OF_HOURS_DETAIL_DAY_PREFIX' | translate }}
            <span class="overnight-notice__emphasis">{{
              overnightCollectionDayLabel
            }}</span
            >.
          </p>
        </div>

        <div
          class="w-full text-center mt-[1rem]"
          *ngIf="quotationDate && !isOutOfHours"
        >
          <p class="text-[14px] font-semibold mb-1">
            {{
              'MODAL.QUOTATION_DATE' | translate : { date: quotationDate }
            }}
          </p>
          <p class="text-[11px] m-0">
            {{ 'MODAL.DENOMINATIONS_NOTE' | translate }}
          </p>
        </div>
      </div>

      <div
        class="flex flex-wrap justify-center mx-auto px-[0.5rem] my-[1rem]"
        *ngIf="reservationStep === 2"
      >
        <p
          class="w-full text-center mb-[1rem] text-[14px]"
          *ngIf="stockApprovalRequired"
          role="status"
        >
          {{ 'INVENTORY.APPROVAL_WINDOW' | translate }}
        </p>
        <app-pickup-schedule
          [timeSlots]="availableTimeSlots"
          [selectedTimeSlotId]="selectedSlotId"
          [isOutOfHours]="isOutOfHours"
          [collectionDateLabel]="collectionDateLabel"
          (timeSlotSelected)="onTimeSlotSelected($event)"
        ></app-pickup-schedule>
      </div>

      <div
        class="flex flex-wrap justify-center mx-auto px-[0.5rem] my-[1rem]"
        *ngIf="reservationStep === 1 && !isPromoLocked && !showPromoSplitWarning"
      >
        <div class="w-full mt-[1rem]">
          <app-branch-selector
            [branch]="sucursal"
            [branches]="branches"
            (branchSelected)="onBranchSelected($event)"
          ></app-branch-selector>
        </div>
      </div>

      <div class="mx-[1rem]" *ngIf="reservationStep === 3 && cotizacion">
        <app-reservation-confirmation
          [cotizacion]="cotizacion"
          [sucursal]="sucursal"
          [selectedTimeSlot]="getSelectedTimeSlot()"
          [branchTimezone]="branchTimezone"
          [estimatedPoints]="estimatedPoints"
          [exchanges]="divisas"
          (canceled)="anterior()"
          (confirmed)="completar()"
        ></app-reservation-confirmation>
      </div>
    </div>
  </div>
  <div class="floating-buttons-container">
    <div
      class="flex flex-wrap justify-center gap-[1rem] mb-[0.5rem] mt-[1rem] mx-auto w-full md:max-w-[500px] px-[1rem]"
      *ngIf="showPromoSplitWarning"
    >
      <div class="flex-1">
        <button
          class="promo-split-warning__btn-modify border border-white/80 bg-transparent text-white hover:bg-white/10 w-full mb-[1rem] py-2 px-4 rounded"
          (click)="modifyPromoAmount()"
        >
          <mat-icon svgIcon="edit"></mat-icon>
          {{ 'MODAL.PROMO_SPLIT.BUTTON_MODIFY' | translate }}
        </button>
      </div>
      <div class="flex-1">
        <button
          mat-raised-button
          color="accent"
          class="button w-full"
          (click)="siguiente()"
          [disabled]="isProcessingSiguiente"
        >
          {{
            isProcessingSiguiente
              ? ('MODAL.BUTTON_WAIT' | translate)
              : ('MODAL.BUTTON_NEXT' | translate)
          }}
          <mat-icon
            iconPositionEnd
            [class.mat-loading-circle-icon]="isProcessingSiguiente"
            [svgIcon]="
              isProcessingSiguiente ? 'loading_circle' : 'arrow_forward'
            "
          ></mat-icon>
        </button>
      </div>
    </div>
    <div
      class="flex flex-wrap justify-center gap-[1rem] mb-[0.5rem] mt-[1rem] mx-auto w-full md:max-w-[500px] px-[1rem]"
      *ngIf="!showPromoSplitWarning"
    >
      <div class="flex-1" *ngIf="reservationStep === 1">
        <button
          class="border border-white/80 bg-transparent text-white hover:bg-white/10 w-full mb-[1rem] py-2 px-4 rounded"
          (click)="onNoClick()"
        >
          {{ 'MODAL.BUTTON_CANCEL' | translate }}
        </button>
      </div>
      <div class="flex-1" *ngIf="[2, 3].includes(reservationStep)">
        <button
          class="border border-white/80 bg-transparent text-white hover:bg-white/10 w-full mb-[1rem] py-2 px-4 rounded"
          (click)="anterior()"
        >
          {{ 'MODAL.BUTTON_BACK' | translate }}
        </button>
      </div>
      <div *ngIf="[1, 2].includes(reservationStep)" class="flex-1">
        <button
          mat-raised-button
          color="accent"
          class="button w-full"
          (click)="siguiente()"
          [disabled]="
            marketInactive ||
            !cotizacion ||
            (reservationStep === 1 && !!quoteValidationErrorKey) ||
            (reservationStep === 2 && !selectedSlotId) ||
            isProcessingSiguiente
          "
        >
          {{
            isProcessingSiguiente
              ? ('MODAL.BUTTON_WAIT' | translate)
              : ('MODAL.BUTTON_NEXT' | translate)
          }}
          <mat-icon
            iconPositionEnd
            [class.mat-loading-circle-icon]="isProcessingSiguiente"
            [svgIcon]="
              isProcessingSiguiente ? 'loading_circle' : 'arrow_forward'
            "
          ></mat-icon>
        </button>
      </div>
      <div *ngIf="[3].includes(reservationStep)" class="flex-1">
        <button
          mat-raised-button
          color="accent"
          class="button w-full"
          (click)="completar()"
          [disabled]="isProcessingCompletar"
        >
          {{
            isProcessingCompletar
              ? ('MODAL.BUTTON_WAIT' | translate)
              : ('MODAL.BUTTON_CONFIRM_RESERVATION' | translate)
          }}
          <mat-icon
            [class.mat-loading-circle-icon]="isProcessingCompletar"
            [svgIcon]="isProcessingCompletar ? 'loading_circle' : 'done'"
          ></mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
